<div class="overflow-hidden w-full flex flex-col bg-white p-5">
  <div class="flex flex-col">
    <div class="flex justify-between items-center">
      <div class="title text-3xl">{{ 'title.cancel.subscription' | transloco }}</div>
      <ion-icon name="close-outline" class="cursor-pointer text-4xl" (click)="closeModal()"></ion-icon>
    </div>
    <div class="mt-2">
      <span [innerHTML]="'text.cancel.subscription' | transloco"></span>
    </div>
    <div class="mt-5">
      <button class="button red w-full" (click)="deleteProtocol()" [disabled]="pending" [class.loading]="pending">{{ 'button.submit' | transloco }}</button>
      <button class="button stroked w-full" (click)="closeModal()" [disabled]="pending">{{ 'button.cancel' | transloco }}</button>
    </div>
  </div>
</div>
